import BaseAction from "../base-action";
import {ActionTypeEnum} from "../../base/training-literals";

class AlignWithPhysical extends BaseAction {
    placeOnSurfaceFirst;
    movementAnchor;
    rotationAnchor;
    timelines;
    markerImage;
    backupTimelines;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.ALIGN_WITH_PHYSICAL;
        this.placeOnSurfaceFirst = props.placeOnSurfaceFirst || false;
        this.movementAnchor = props.movementAnchor || {};
        this.rotationAnchor = props.rotationAnchor || {};
        this.timelines = props.timelines || [];
        this.markerImage = props.markerImage || '';
        this.backupTimelines = props.backupTimelines || [];
    }

    get(props = {}) {
        return {
            type: this.actionType,
            placeOnSurfaceFirst: props.placeOnSurfaceFirst || this.placeOnSurfaceFirst,
            movementAnchor: props.movementAnchor || this.movementAnchor,
            rotationAnchor: props.rotationAnchor || this.rotationAnchor,
            timelines: props.timelines || this.timelines,
            markerImage: props.markerImage || this.markerImage,
            backupTimelines: props.backupTimelines || this.backupTimelines
        }
    }
}

export default AlignWithPhysical;
